import config from "../../config";
const endpoint = "/dinamiks";
const isServer = typeof window == "undefined" ? true : false;
let options = {};

if (isServer && config.ENVIROMENT) {
  const https = require("https");

  options = {
    agent: new https.Agent({
      rejectUnauthorized: false,
    }),
  };
}

export const fetchDinamiks = async (id) => {
  try {
    const response = await fetch(
      config.API_HOST + endpoint + `?path.path=${id}`,
      options
    ).then((j) => j.json());
    return response;
  } catch (e) {
    console.log(e);
  }
};
